<template>
  <resource-base
    :loading-display="false"
    :is-management-mode="isManagementMode"
    :resource="resource"
  >
    <template v-slot:display>
      <b-container>
        <display :resource="resource" @appLog="appLog" />
      </b-container>
    </template>
    <template v-slot:activity>
      <activity :resource="resource" />
    </template>
    <template v-slot:settings>
      <settings
        :publishing="publishing"
        :resource="resource"
        @resource-updated="handleRefreshResource"
        @update-settings="handleUpdateSettings"
      />
    </template>
  </resource-base>
</template>

<script>
import ResourceBase from "../resourceBase";
import Display from "./sections/display";
import Activity from "./sections/activity";
import Settings from "./sections/settings";
export default {
  name: "Resource_MatchGame",
  components: {
    ResourceBase,
    Display,
    Activity,
    Settings
  },
  props: {
    isManagementMode: {
      type: Boolean,
      default: false
    },

    publishing: {
      type: Object,
      required: false,
      default: () => {}
    },
    resource: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      title: this.resource.name,
      imgURL: this.resource.imgURL,
      faIcon: this.resource.icon ? this.resource.icon : "fa-folder"
    };
  },
  methods: {
    handleRefreshResource() {
      //console.log('refreshing resource');
      this.$emit("refresh-publishing");
    },
    showResource() {
      this.show = true;
    },
    appLog(data) {
      //Use Mixins
      this.$emit("appLog", data);
    },
    handleUpdateSettings(settings) {
      //can be a mixin
      this.$emit("update-settings", settings);
    }
  },
  mounted() {
    console.log(`ResourceMatchGame Store is  ${this.$store}`);
  }
};
</script>

<style lang="scss">
img {
  cursor: pointer;
}
</style>
